import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import api from "../../lib/api";
import Reveal, { Eyebrow } from "../../components/Reveal";

export default function ReviewsSection() {
  const [reviews, setReviews] = useState(null);

  useEffect(() => {
    api.get("/reviews").then((r) => setReviews(r.data)).catch(() => setReviews([]));
  }, []);

  return (
    <section data-testid="reviews-section" className="py-16 md:py-24 lg:py-28 bg-paper">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <Reveal>
          <Eyebrow>Client Feedback</Eyebrow>
          <h2 className="mt-4 font-display font-bold text-3xl md:text-5xl tracking-tight text-ink display-expanded leading-[1.02]">
            What Our Clients Say
          </h2>
        </Reveal>

        {reviews === null ? (
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
            {[0, 1, 2].map((i) => <div key={i} className="h-44 bg-line/50 animate-pulse" />)}
          </div>
        ) : reviews.length === 0 ? (
          <Reveal delay={0.08}>
            <div data-testid="reviews-empty-state" className="mt-12 border border-line bg-white px-8 py-12 text-center">
              <p className="font-display font-semibold text-lg text-ink">Reviews from recent clients are being collected</p>
              <p className="mt-2.5 text-sm text-slate2 max-w-md mx-auto leading-relaxed">
                We only publish genuine feedback from real Razor Build projects. Ask us about past clients and completed work when we talk.
              </p>
            </div>
          </Reveal>
        ) : (
          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {reviews.map((r, i) => (
              <Reveal key={r.id} delay={i * 0.07}>
                <figure data-testid={`review-${r.id}`} className="bg-white border border-line p-7 h-full flex flex-col">
                  <div className="flex gap-1 mb-4" aria-label={`${r.rating} out of 5 stars`}>
                    {Array.from({ length: 5 }).map((_, s) => (
                      <Star key={s} className={`w-4 h-4 ${s < r.rating ? "text-gold fill-gold" : "text-line"}`} />
                    ))}
                  </div>
                  <blockquote className="text-sm text-ink/80 leading-relaxed flex-1">“{r.text}”</blockquote>
                  <figcaption className="mt-5 pt-4 border-t border-line">
                    <p className="font-display font-semibold text-sm text-ink">{r.name}</p>
                    {r.project_type && <p className="font-mono text-[10px] tracking-[0.18em] uppercase text-slate2 mt-1">{r.project_type}</p>}
                  </figcaption>
                </figure>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
